// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"519":"93f0f26a","787":"909b9ed9","812":"43718f5d","994":"5509e7f6"}[chunkId] + ".chunk.js";
};